import {
  EXCEL_DATA_RESET,
  EXCEL_SET_DATA,
  EXCEL_SET_ITEMS,
  EXCEL_SET_TAB,
} from "../../constants/excelConstants";

export const excelDataReset = () => {
  return {
    type: EXCEL_DATA_RESET,
  };
};

export const excelSetData = (excelData) => {
  return {
    type: EXCEL_SET_DATA,
    excelData,
  };
};

export const excelSetTab = (activeTab) => {
  return {
    type: EXCEL_SET_TAB,
    activeTab,
  };
};

export const excelSetItems = (savedItems) => {
  return {
    type: EXCEL_SET_ITEMS,
    savedItems,
  };
};
